<template>
  <a-card :bordered="false">
    <div>
      <div class="operation-wrap" style="display: flex;flex-wrap: wrap">
      </div>
      <a-table
        row-key="id"
        :data-source="table.data"
        style="width: 100%">
        <a-table-column
          data-index="id"
          title="序号">
        </a-table-column>
        <a-table-column
          data-index="name"
          title="语言">
        </a-table-column>
        <a-table-column
          data-index="code"
          :title="$t('CODE')||'编码'">
        </a-table-column>
        <a-table-column
          data-index="isActive"
          title="是否有效">
          <template slot-scope="text, record">
            <a-switch
              @change="editIsActive(record.id,record.isActive)"
              v-model="record.isActive"
              active-value="YES"
              inactive-value="NO">
            </a-switch>
          </template>
        </a-table-column>
        <a-table-column
          data-index="icon"
          title="图标"
          width="180">
          <template slot-scope="text,record">
            <span :class="record.icon"></span>
          </template>
        </a-table-column>
      </a-table>
    </div>
  </a-card>
</template>

<script>
import {
  _queryLanguages,
  _updateLanguage,
} from '@/api/sys/languageApi';

async function getLanguageList() {
  let direction = this.table.sort.order;
  if (direction) {
    direction = direction === 'ascend' ? 'ASC' : 'DESC';
  }
  const { content } = await _queryLanguages({
    page: this.table.query.page,
    size: this.table.query.size,
    sort: this.table.sort.prop,
    direction,
    date: this.table.query.date,
  });
  this.table.data = content;
}

function editIsActive(languageId, isActive) {
  const result = _updateLanguage(languageId, {
    isActive,
  });
  if (result) {
    this.$message.success(this.$t('UPDATE_SUCCESS'));
  }
}

export default {
  name: 'LanguageList',
  data() {
    return {
      form: {
        data: {
          id: null,
        },
        visible: false,
      },
      table: {
        data: [],
        query: {
          page: 1,
          size: 100,
          total: 0,
        },
        sort: {
          order: 'descending',
        },
      },
    };
  },
  methods: {
    getLanguageList,
    editIsActive,
  },
  created() {
    this.getLanguageList();
  },
};
</script>

<style scoped>
  .flag-icon {
    height: 20px;
    width: 27px;
  }
</style>
